module.exports = __webpack_public_path__ + "static/media/yin-yang.9d12326e.svg";